import * as React from "react";
const SvgPersonCircle24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11 2a9 9 0 0 0-6 15.708V16a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1.708A9 9 0 0 0 11 2Zm4 17.064V16a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3.064A8.963 8.963 0 0 0 11 20a8.963 8.963 0 0 0 4-.936ZM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11Zm11-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM7 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgPersonCircle24Px;
